import { z } from 'zod';
export const sequenceBranchRuleSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('lead_has_tag'),
        tag: z.string().min(1),
        goto_step_order: z.number().int().min(0),
    }),
    z.object({
        type: z.literal('lead_status_in'),
        statuses: z.array(z.string().min(1)).min(1),
        goto_step_order: z.number().int().min(0),
    }),
    z.object({
        type: z.literal('lead_status_not_in'),
        statuses: z.array(z.string().min(1)).min(1),
        goto_step_order: z.number().int().min(0),
    }),
]);
/** First matching rule wins; else defaultNext = currentStepOrder + 1 */
export function resolveNextStepOrder(currentStepOrder, rules, lead, maxStepOrder) {
    const parsed = z.array(sequenceBranchRuleSchema).safeParse(rules ?? []);
    const list = parsed.success ? parsed.data : [];
    for (const rule of list) {
        if (rule.type === 'lead_has_tag' && lead.tags.includes(rule.tag)) {
            return Math.min(rule.goto_step_order, maxStepOrder);
        }
        if (rule.type === 'lead_status_in' && rule.statuses.includes(lead.status)) {
            return Math.min(rule.goto_step_order, maxStepOrder);
        }
        if (rule.type === 'lead_status_not_in' && !rule.statuses.includes(lead.status)) {
            return Math.min(rule.goto_step_order, maxStepOrder);
        }
    }
    return currentStepOrder + 1;
}
/** Throws when goto_step_order is missing or equals current step. */
export function validateBranchTargets(steps) {
    const orders = new Set(steps.map((s) => s.step_order));
    const issues = [];
    for (const step of steps) {
        const parsed = z.array(sequenceBranchRuleSchema).safeParse(step.branch_rules ?? []);
        const rules = parsed.success ? parsed.data : [];
        for (const rule of rules) {
            if (!orders.has(rule.goto_step_order)) {
                issues.push({
                    step_order: step.step_order,
                    message: `Branch verwijst naar onbekende stap ${rule.goto_step_order}`,
                });
            }
            if (rule.goto_step_order === step.step_order) {
                issues.push({
                    step_order: step.step_order,
                    message: 'Branch kan niet naar dezelfde stap verwijzen',
                });
            }
        }
    }
    return issues;
}
//# sourceMappingURL=branchRules.js.map